(function () {
  var PREFILL_KEY = 'explora_signup_email_prefill';

  function handleSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var container = form.closest('[data-newsletter-redirect]');
    if (!container) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var emailInput = form.querySelector('input[type="email"]');
    var termsInput = container.querySelector('.signup-container--terms input[type="checkbox"]');

    if (!emailInput || !emailInput.checkValidity()) {
      emailInput && emailInput.reportValidity();
      return;
    }

    if (termsInput && !termsInput.checkValidity()) {
      termsInput.reportValidity();
      return;
    }

    try {
      sessionStorage.setItem(PREFILL_KEY, emailInput.value.trim());
    } catch (e) {
      /* private mode / blocked storage — still redirect */
    }

    var url = new URL(form.getAttribute('action'), window.location.origin);
    ['source', 'source_template'].forEach(function (name) {
      var input = form.elements[name];
      if (input && input.value) url.searchParams.set(name, input.value);
    });

    window.location.assign(url.toString());
  }

  function bindForms() {
    document.querySelectorAll('[data-newsletter-redirect] form.signup-form').forEach(function (form) {
      if (form.dataset.redirectBound === 'true') return;
      form.dataset.redirectBound = 'true';
      form.addEventListener('submit', handleSubmit, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindForms);
  } else {
    bindForms();
  }

  document.addEventListener('shopify:section:load', bindForms);
})();
